





















import Vue from 'vue';
import ReservationForm from '@/components/Forms/ReservationForm.vue';

export default Vue.extend({
  name: 'reserve',
  components: {
    ReservationForm,
  },
  async created() {
    (this as any).updateQueryParameters();

    (this as any).startLoading();

    await (this as any).getLatestData();

    (this as any).stopLoading();
  },
});
